import { render, staticRenderFns } from "./viewforuser.vue?vue&type=template&id=60f8d7b3&scoped=true&"
import script from "./viewforuser.vue?vue&type=script&lang=js&"
export * from "./viewforuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f8d7b3",
  null
  
)

export default component.exports